import { render, staticRenderFns } from "./About.vue?vue&type=template&id=5e9c77be&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
import style0 from "./About.vue?vue&type=style&index=0&id=5e9c77be&prod&lang=scss&scoped=true"
import style1 from "./About.vue?vue&type=style&index=1&id=5e9c77be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9c77be",
  null
  
)

export default component.exports